import { NgModule } from "@angular/core";
import { SharedModule } from "../shared-module/shared.module";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ReportingRoutingModule } from "./reporting-routing.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";

import {
  ReportsListComponent,
  ReportDetailComponent
} from "./pages";

import {
  ReportTableComponent
} from "./components";
import { ReportSortDirective } from "./directives/report-sort.directive";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { A11yModule } from "@angular/cdk/a11y";
import { ReportGraphComponent } from './components/report-graph/report-graph.component';
import { BarVertical2dRefLinesComponent } from './components/bar-vertical-2d-ref-lines/bar-vertical-2d-ref-lines.component';

@NgModule({
  declarations: [
    ReportsListComponent,
    ReportDetailComponent,
    ReportTableComponent,
    ReportSortDirective,
    ReportGraphComponent,
    BarVertical2dRefLinesComponent
  ],
  imports: [
    CommonModule,
    ReportingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatCheckboxModule,
    A11yModule,
    NgxChartsModule
],
  exports: []
})
export class ReportingModule {
}
